/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  MarketSummary,
  MarketSummaryFromJSON,
  MarketSummaryFromJSONTyped,
  MarketSummaryToJSON,
} from "./";

/**
 *
 * @export
 * @interface MarketSummaryIEnumerableControllerResponse
 */
export interface MarketSummaryIEnumerableControllerResponse {
  /**
   *
   * @type {Array<MarketSummary>}
   * @memberof MarketSummaryIEnumerableControllerResponse
   */
  data?: Array<MarketSummary> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof MarketSummaryIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function MarketSummaryIEnumerableControllerResponseFromJSON(
  json: any,
): MarketSummaryIEnumerableControllerResponse {
  return MarketSummaryIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function MarketSummaryIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarketSummaryIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(MarketSummaryFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function MarketSummaryIEnumerableControllerResponseToJSON(
  value?: MarketSummaryIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(MarketSummaryToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
